export function someGetter (/* state */) {
}